import { Link } from 'react-router-dom';
import { useT } from '@dia/i18n';
import { Screen } from '@dia/ui';

export function NotFound() {
  const { t } = useT();
  return (
    <Screen title={t('error.not_found')}>
      <Link to="/" className="text-accent underline underline-offset-4">
        {t('action.back')}
      </Link>
    </Screen>
  );
}
